module.exports = __webpack_public_path__ + "img/111.0e6499cf.png";